import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState = {
  step: 1, 
  selectedService: '',
};

const stepSlice = createSlice({
  name: 'step',
  initialState,
  reducers: {
    nextStep: (state) => {
      state.step += 1;
    },
    previousStep: (state) => {
      state.step -= 1;
    },
    setStep: (state, action) => {
      state.step = action.payload;
    },
    setSelectedService: (state, action: PayloadAction<string>) => {
      state.selectedService = action.payload;
    }
  },
});

export const { nextStep, previousStep, setStep,setSelectedService } = stepSlice.actions;
export default stepSlice.reducer;